import { render, staticRenderFns } from "./organization-members-view.vue?vue&type=template&id=240c2718&scoped=true&"
import script from "./organization-members-view.vue?vue&type=script&lang=js&"
export * from "./organization-members-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-members-view.vue?vue&type=style&index=0&id=240c2718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c2718",
  null
  
)

export default component.exports